<!-- <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" m-dropdown-toggle="click"> -->
<a href="#" class="m-nav__link m-dropdown__toggle">
	<h4 class="octo-turkred"
		style="padding-top: 15px !important; padding-right: 10px; vertical-align: middle; min-height: 100%; font-weight: bold">
		{{ nameSurname }}</h4>
	<span class="m-topbar__userpic">
		<img [ngStyle]="{'border': customerService.settings.name != 'sef' ? '2px solid #941a1d' : '2px solid #84bd00'}"
			[attr.src]="'assets/app/media/img/users/user.png'" class="m--img-rounded m--marginless m--img-centered " />
	</span>
</a>
<div class="m-dropdown__wrapper">
	<span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
	<div class="m-dropdown__inner">
		<div class="m-dropdown__header m--align-center" #mProfileDropdown style="background-size: cover;"
			[style.background-image]="avatarBg">
			<div class="m-card-user m-card-user--skin-dark">
				<!--				<div class="m-card-user__pic">-->
				<!--					<img src="{{avatar}}" class="m&#45;&#45;img-rounded m&#45;&#45;marginless" alt="" />-->
				<!--				</div>-->
				<div class="m-card-user__details">
					<span class="m-card-user__name m--font-weight-500">
						{{ nameSurname + ' (' + role + ')' }}
					</span>
					<span class="m-card-user__email m--font-weight-300 m-link">
						{{ email }}
					</span>
				</div>
			</div>
		</div>
		<div class="m-dropdown__body">
			<div class="m-dropdown__content">
				<ul class="m-nav m-nav--skin-light">
					<li class="m-nav__item">
						<button class="btn btn-danger m-btn--square btn-block btn-sm" (click)="logout()">Çıkış
							Yap</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
<!-- </li> -->